import React, { useState, useEffect } from "react";
import RequestHandler from "util/RequestHandler";
import { defaultValidateMessages } from "./Helper";

import { Form, Col, Row, Button, Switch, Input, Select } from "antd";
import { PlusOutlined } from "@ant-design/icons";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};

const PaymentSetAddForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const [posCommissions, setPosCommissions] = useState([]);

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }

    RequestHandler.get(`/PosCollectionCommissionDefinition`).then(
      (response) => {
        setPosCommissions(response.value);
      }
    );
  }, [props.data]);

  const onSuccess = () => {
    form.resetFields();
    if (props.onSuccess) props.onSuccess();
  };

  const onFinish = (values) => {
    const banks = [];

    for (let index = 1; index <= 12; index++) {
      if (values[`isInstallmentActive${index}`] != undefined) {
        values[`isInstallmentActive${index}`].map((bankInfo) => {
          let isPushArray = true;
          const hasBanks = banks.find((x) => x.posCollectionCommissionDefinitionId == bankInfo);

          let bankObj = {};

          if (hasBanks) {
            isPushArray = false;
            bankObj = hasBanks;
          }

          bankObj[`isInstallmentActive${index}`] = true;

          if (isPushArray) {
            bankObj["posCollectionCommissionDefinitionId"] = bankInfo;
            banks.push(bankObj);
          }
        });
      }
    }

    values.banks = banks;
    RequestHandler.post(`/PaymentSet`, values).then((response) => {
      setLoading(false);
      if (response.success) {
        form.resetFields();
        onSuccess();
      }
    });
  };

  const renderInstallmentInput = (installmentCount) => {
    return (
      <Form.Item
        label={installmentCount + " Taksit"}
        name={"isInstallmentActive" + installmentCount}
      >
        <Select
          mode="multiple"
          allowClear
          showSearch
          placeholder="Aktif olmasını istediğiniz bankaları seçiniz."
          filterOption={(input, option) =>
            option.children
              .toLocaleLowerCase("tr-TR")
              .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
          }
        >
          {posCommissions.map((item) => (
            <Select.Option key={item.id} value={item.id}>
              {item.bankName + " (" + item.cardName + ")"}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    );
  };

  return (
    <>
      <Form
        {...formItemLayout}
        validateMessages={defaultValidateMessages}
        form={form}
        name="paymentSetAdd"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={() => setLoading(false)}
      >
        <Row>
          <Col span={24}>
            <Form.Item
              label="Ödeme Seti Adı"
              name="name"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Tek Çekim"
              name="isInstallmentActive1"
              valuePropName="checked"
            >
              <Select
                mode="multiple"
                allowClear
                showSearch
                placeholder="Aktif olmasını istediğiniz bankaları seçiniz."
                filterOption={(input, option) =>
                  option.children
                    .toLocaleLowerCase("tr-TR")
                    .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                }
              >
                {posCommissions.map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.bankName + " (" + item.cardName + ")"}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            {renderInstallmentInput(2)}
            {renderInstallmentInput(3)}
            {renderInstallmentInput(4)}
            {renderInstallmentInput(5)}
            {renderInstallmentInput(6)}
            {renderInstallmentInput(7)}
            {renderInstallmentInput(8)}
            {renderInstallmentInput(9)}
            {renderInstallmentInput(10)}
            {renderInstallmentInput(11)}
            {renderInstallmentInput(12)}
          </Col>
        </Row>
        <Row justify="space-between">
          <Col></Col>
          <Col>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              htmlType="submit"
              onClick={() => setLoading(true)}
              loading={loading}
            >
              Ekle
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
};
export default PaymentSetAddForm;
